export default {
	name: 'Convention.Schedule.Suggestion.Submit',
	path: 'convention/schedule/suggestions/:id/submit',
	meta: {
		auth: true,
		parents: ['Convention.Schedule.Suggestions']
	}
}